import controller from './dashboard.controller';

const template = require('./dashboard.html');

export default {
    controller,
    template
};
